'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getTransformResponse;

var _defaults = require('axios/lib/defaults');

var _defaults2 = _interopRequireDefault(_defaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getTransformResponse() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!options.transformResponse) {
    // eslint-disable-next-line no-param-reassign
    options.transformResponse = _defaults2.default.transformResponse.slice();
  }
  return options.transformResponse;
}